/* eslint-disable require-jsdoc */
import { Avatar, createStyles, Icon, IconButton, ListItem, ListItemAvatar, ListItemIcon, ListItemSecondaryAction, ListItemText, makeStyles } from '@material-ui/core';
import { InsertDriveFile } from '@material-ui/icons';
import { PathHelper } from '@sensenet/client-utils';
import React from 'react';
import { renderIconDefault } from "../icon.js";
function getAppPathAndContent(PATHS, targetPath) {
  const matches = Object.entries(PATHS).filter(([, config]) => config.snPath && targetPath.startsWith(config.snPath)).sort((a, b) => b[1].snPath.length - a[1].snPath.length);
  if (!matches[0]) return undefined;
  const [, config] = matches[0];
  const contentePath = targetPath.substring(config.snPath.length);
  return {
    appPath: config.appPath,
    contentePath
  };
}
function buildCustomPath(path, action, contentePath) {
  const customPath = path.replace(':browseType', 'explorer').replace('/:path', '') // Remove the path parameter
  .replace(':action?', action || 'default');
  const url = new URL(window.location.origin);
  url.pathname = customPath;
  url.searchParams.set('content', contentePath);
  return url.toString();
}
const useStyles = makeStyles(() => createStyles({
  referenceItemText: {
    textAlign: 'left',
    paddingRight: 15,
    cursor: 'pointer',
    '&[data-clickable="true"]:hover': {
      textDecoration: 'underline'
    }
  }
}));

/**
 * Represents a default renderer for reference grid row
 */
export const DefaultItemTemplate = props => {
  const {
    content,
    repository,
    paths
  } = props;
  const classes = useStyles();
  const renderIcon = item => {
    if (repository !== null && repository !== void 0 && repository.schemas.isContentFromType(item, 'User')) {
      var _item$Avatar, _item$DisplayName;
      const avatarUrl = (_item$Avatar = item.Avatar) === null || _item$Avatar === void 0 ? void 0 : _item$Avatar.Url;
      if (avatarUrl) {
        return /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
          alt: item.FullName,
          src: avatarUrl && repository !== null && repository !== void 0 && repository.configuration.repositoryUrl ? `${repository.configuration.repositoryUrl}${avatarUrl}` : ''
        }));
      }
      return /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
        alt: item.DisplayName
      }, (_item$DisplayName = item.DisplayName) === null || _item$DisplayName === void 0 ? void 0 : _item$DisplayName.split(' ').map(namePart => namePart[0]).join('.')));
    }
    if (repository !== null && repository !== void 0 && repository.schemas.isContentFromType(item, 'Image') && (!item.PageCount || item.PageCount <= 0)) {
      return /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement("img", {
        "data-test": "reference-selection-image",
        alt: item.DisplayName,
        src: `${repository === null || repository === void 0 ? void 0 : repository.configuration.repositoryUrl}${item.Path}`,
        style: {
          width: '3em',
          height: '3em',
          objectFit: 'scale-down'
        }
      }));
    }
    if (repository !== null && repository !== void 0 && repository.schemas.isContentFromType(item, 'Image') && item.PageCount && item.PageCount > 0) {
      return /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement("img", {
        "data-test": "reference-selection-image",
        alt: item.DisplayName,
        src: PathHelper.joinPaths(repository === null || repository === void 0 ? void 0 : repository.configuration.repositoryUrl, item.Path, '/Previews', item.Version, 'thumbnail1.png'),
        style: {
          width: '3em',
          height: '3em',
          objectFit: 'scale-down'
        }
      }));
    }
    return /*#__PURE__*/React.createElement(ListItemIcon, {
      style: {
        marginRight: 0
      }
    }, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(InsertDriveFile, null)));
  };
  return /*#__PURE__*/React.createElement(ListItem, {
    style: props.actionName === 'browse' ? {
      padding: 0
    } : undefined,
    key: content.Id,
    button: false
  }, content.Type ? renderIcon(content) : null, /*#__PURE__*/React.createElement(ListItemText, {
    onClick: () => {
      if (content.Id === -1 || !paths) {
        return;
      }
      const referencedItemPaths = getAppPathAndContent(paths, content.Path);
      if (!referencedItemPaths) {
        return;
      }
      const {
        appPath,
        contentePath
      } = referencedItemPaths;
      const fullUrl = buildCustomPath(appPath, props.actionName, contentePath);
      window.location.href = fullUrl;
    },
    primary: content.DisplayName,
    className: classes.referenceItemText,
    "data-clickable": content.Id !== -1
  }), props.actionName && props.actionName !== 'browse' && !props.readOnly ? /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, content.Id > 0 ? /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => {
      var _props$remove;
      return (_props$remove = props.remove) === null || _props$remove === void 0 ? void 0 : _props$remove.call(props, content.Id);
    }
  }, props.renderIcon ? props.renderIcon('remove_circle') : renderIconDefault('remove_circle')) : /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => props.add()
  }, props.renderIcon ? props.renderIcon(content.Id === -1 ? 'add_circle' : 'refresh') : renderIconDefault(content.Id === -1 ? 'add_circle' : 'refresh'))) : null);
};
//# sourceMappingURL=default-item-template.js.map